/**
 * Active-state matchers for navigation items.
 *
 * Every matcher delegates to the router's own `matchPath`, so a nav row can
 * never disagree with the route tree about which route the URL is. Hand-rolled
 * string compares did: an exact `=== "/ui"` missed the `/ui/` spelling, and a
 * bare `startsWith` counted `/ui/skillsets` as a hit on `/ui/skills`.
 *
 * @module MatchNav
 */

import { matchPath } from "react-router-dom"

import { isReportAgentPath } from "@/constants/agents"

/**
 * Matches one route exactly. Trailing slashes are the router's business, so
 * `at("/ui")` matches both `/ui` and `/ui/`.
 */
export const at = (pattern: string) => (pathname: string) =>
  Boolean(matchPath(pattern, pathname))

/** Matches a route and everything nested under it, but not a longer sibling. */
export const under = (prefix: string) => (pathname: string) =>
  Boolean(matchPath(`${prefix}/*`, pathname))

/**
 * The Reports nav item stays active on both /ui/reports and report-surfaced
 * agent routes (AEO, SEO Audit) under /ui/agent/*. Shared by the main and guest
 * menus so the two never drift.
 */
export const reportsMatcher = (pathname: string) =>
  under("/ui/reports")(pathname) || isReportAgentPath(pathname)
